import { SkillGroup } from "@/features/cv/types/skills"
import {
  Code2,
  Database,
  Monitor,
  MessageSquare,
  GitBranch,
  Rocket,
  Building,
  ClipboardList,
  Shield,
  Target,
  Cloud,
  Users,
  Terminal,
  Code,
  CloudCog,
  CloudAlert,
  Cloudy,
  UserRoundPlus,
  GraduationCap,
  ContactRound,
  ChevronLast,
  Zap,
  Lightbulb,
  Heart
} from "lucide-react";

import { FiDollarSign } from "react-icons/fi";
import { FaLaptopHouse } from "react-icons/fa";
import { RiRemoteControlLine, RiUserVoiceLine } from "react-icons/ri";
import { RxExit } from "react-icons/rx";
import { IoPricetagOutline, IoPricetagsOutline } from "react-icons/io5";
import { SiDocker, SiWindows, SiMlflow } from 'react-icons/si';
import { FaHouse } from "react-icons/fa6";
import { TbCloudDollar } from "react-icons/tb";

export const skills: SkillGroup[] = [
  {
    category: 'technology',
    title: 'Technology',
    forcePageBreak: true,
    subGroups: [
      {
        title: 'Code',
        skills: [
          { name: 'TypeScript', icon: <Code2 /> },
          { name: 'Javascript', icon: <Code2 /> },
          { name: 'C# / .NET', icon: <Code2 /> },
          { name: 'Python', icon: <Code2 /> },
          { name: 'Go', icon: <Code2 /> },
          { name: 'SQL', icon: <Code /> },
          { name: 'Bash', icon: <ChevronLast /> },
          { name: 'Powershell', icon: <ChevronLast /> },
        ]
      },
      {
        title: 'Frontend',
        skills: [
          { name: 'HTML', icon: <Monitor /> },
          { name: 'CSS', icon: <Monitor /> },
          { name: 'Angular', icon: <Monitor /> },
          { name: 'React', icon: <Monitor /> },
        ]
      },
      {
        title: 'Database',
        skills: [
          { name: 'ClickHouse', icon: <Database /> },
          { name: 'PostgreSQL', icon: <Database /> },
          { name: 'MySQL', icon: <Database /> },
          { name: 'SQL Server', icon: <Database /> },
          { name: 'Elasticsearch', icon: <Database /> },
        ]
      },
      {
        title: 'Data & Observability',
        skills: [
          { name: 'Parquet', icon: <Database /> },
          { name: 'OpenTelemetry', icon: <CloudAlert /> },
          { name: 'Prometheus', icon: <Monitor /> },
          { name: 'Performance', icon: <Zap /> },
        ]
      },
      {
        title: 'Messaging',
        skills: [
          { name: 'Kafka', icon: <MessageSquare /> },
          { name: 'RedPanda', icon: <MessageSquare /> },
          { name: 'RabbitMQ', icon: <MessageSquare /> },
          { name: 'MQTT', icon: <MessageSquare /> },
        ]
      },
      {
        title: 'Cloud & DevOps',
        skills: [
          { name: 'AWS', icon: <Cloud /> },
          { name: 'Azure', icon: <Cloud /> },
          { name: 'CI + CD', icon: <CloudCog /> },
          { name: 'Docker', icon: <SiDocker size={24} /> },
          { name: 'Serverless', icon: <Cloud /> },
          { name: 'Terraform', icon: <Cloudy /> },
          { name: 'Cloudformation', icon: <Cloudy /> },
        ]
      },
      {
        title: 'Operating Systems',
        skills: [
          { name: 'Linux', icon: <Terminal size={20} /> },
          { name: 'Windows', icon: <SiWindows /> },
        ]
      },
    ]
  },
  {
    category: 'business',
    title: 'Business',
    forcePageBreak: true,
    skills: [
      { name: 'Start-ups', icon: <Lightbulb /> },
      { name: 'Scale-ups', icon: <Rocket /> },
      { name: 'Investment', icon: <FiDollarSign size={24} /> },
      { name: 'Due Diligence', icon: <ClipboardList /> },
      { name: 'Compliance', icon: <Shield /> },
      { name: 'Lean', icon: <SiMlflow size={24} /> },
      { name: 'Pre-sales', icon: <IoPricetagOutline size={24} /> },
      { name: 'Sales', icon: <IoPricetagsOutline size={24} /> },
      { name: 'Acquisitions', icon: <RxExit /> },
      { name: 'Cost Control', icon: <TbCloudDollar size={24} /> },

    ]
  },
  {
    category: 'industry',
    title: 'Industry',
    skills: [
      { name: 'Energy Trading', icon: <Zap /> },

      { name: 'Insurance', icon: <Shield /> },
      { name: 'Public Sector', icon: <Building /> },
      { name: 'Proptech', icon: <FaLaptopHouse size={24} /> },
      { name: 'Housing', icon: <FaHouse size={24} /> },
      { name: 'IoT', icon: <RiRemoteControlLine size={24} /> },
      { name: 'Marketing', icon: <Target /> },
      { name: 'Loyalty', icon: <Heart /> },
      { name: 'SaaS', icon: <Cloud /> },

    ]
  },
  {
    category: 'team',
    title: 'Team',
    skills: [
      { name: 'Building Teams', icon: <UserRoundPlus /> },
      { name: 'Agile / Scrum', icon: <Users /> },
      { name: 'Remote Teams', icon: <ContactRound /> },
      { name: 'Mentoring', icon: <GraduationCap /> },
      { name: 'Process Design', icon: <GitBranch /> },
      { name: 'Board Collaboration', icon: < RiUserVoiceLine size={24} /> },
    ]
  }
];
